/**
 * Common toaster utility for displaying notifications across the application
 */
export type ToastType = 'success' | 'error' | 'loading';

export interface ToastOptions {
  autoRemove?: boolean;
  duration?: number; // in milliseconds
}

export const showToast = (
  type: ToastType, 
  text: string, 
  options: ToastOptions = { autoRemove: true, duration: 3000 }
) => {
  // Remove any existing toast
  const existingToast = document.getElementById('app-toast');
  if (existingToast) {
    existingToast.remove();
  }

  // Create new toast element
  const toast = document.createElement('div');
  toast.id = 'app-toast';
  
  // Set class based on type
  let alertClass = 'alert-info'; // Default for loading
  let borderColor = '#17a2b8'; // Info blue
  let icon = 'fa-spinner fa-spin';
  let label = 'Loading...';
  
  if (type === 'success') {
    alertClass = 'alert-success';
    borderColor = '#28a745';
    icon = 'fa-check-circle';
    label = 'Success!';
  } else if (type === 'error') {
    alertClass = 'alert-danger';
    borderColor = '#dc3545';
    icon = 'fa-exclamation-circle';
    label = 'Error!';
  }
  
  toast.innerHTML = `
    <div class="alert ${alertClass} alert-dismissible fade show" style="
      position: fixed; 
      top: 20px; 
      right: 20px; 
      z-index: 9999; 
      min-width: 350px; 
      max-width: 500px; 
      border-left: 4px solid ${borderColor};
      box-shadow: 0 4px 15px rgba(0,0,0,0.2);
      backdrop-filter: blur(10px);
      background: rgba(255, 255, 255, 0.95);
    ">
      <div class="d-flex align-items-center">
        <div class="me-3">
          <i class="fas ${icon}" style="font-size: 1.2em; color: ${borderColor};"></i>
        </div>
        <div class="flex-grow-1">
          <strong>${label}</strong><br/>
          <span style="font-size: 0.9em;">${text}</span>
        </div>
      </div>
      <button type="button" class="close" onclick="document.getElementById('app-toast').remove()" title="Close notification" style="position: absolute; top: 10px; right: 15px; z-index: 1000;">
        <span style="font-size: 1.2em; color: #666;">&times;</span>
      </button>
    </div>
  `;
  
  // Add to page
  document.body.appendChild(toast);
  
  // Auto-remove with different timers based on type and options
  if (options.autoRemove && type !== 'loading') {
    const duration = type === 'error' ? (options.duration || 5000) : (options.duration || 3000);
    setTimeout(() => {
      document.getElementById('app-toast')?.remove();
    }, duration);
  }
};

export const removeToast = () => {
  document.getElementById('app-toast')?.remove();
};